import Layout from '@/components/Layout';
import React, { useEffect, useState } from 'react';
import type { GetServerSideProps, GetServerSidePropsContext, NextPage } from 'next';
import { getToken } from "next-auth/jwt";
import Button from '@mui/material/Button';
import EditorModal from '@/components/EditorModal';
import Typography from '@mui/material/Typography';
import { Blog } from "@/utils/types";
import Divider from '@mui/material/Divider';
import BlogCard from '@/components/BlogCard';
import { ContentData } from '@/utils/types';

export const getServerSideProps: GetServerSideProps = async (context: GetServerSidePropsContext) => {
  const token = await getToken({ req: context.req });
  const isAdmin = token?.role === 'Admin';
  return {
    props: { isAdmin }, // Pass isAdmin to the page component
  };
};

interface BlogProps {
  isAdmin: boolean;
  placeholder?: string;
}

const Page: NextPage<BlogProps> = ({ isAdmin, placeholder }) => {

  const emptyContentData: ContentData = {
    title: '',
    subtitle: '',
    content: ''
  };

  const [blogs, setBlogs] = useState<Array<Blog>>([]);
  const [refresh, setRefresh] = useState(false);
  const [content, setContent] = useState(emptyContentData);
  const [openModal, setOpenModal] = useState(false);
  const [mode, setMode] = useState<'Add' | 'Edit'>('Add');
  const [_id, setId] = useState(0);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Fetch from the server whenever the state changes
useEffect(() => {
  const fetchData = async () => {
    const res = await fetch('/api/blogs');
    const Blog = await res.json();
    setBlogs(Blog);
  };
  fetchData();
}, [refresh]);

  const handleAddButtonClick = () => {
    setContent(emptyContentData);
    setMode('Add');
    setOpenModal(true);
  };


  const handleSave = async(data: ContentData) => {
    setContent(data);
    const { title, subtitle, content } = data;
    console.log('Title:', title);
    console.log('Subtitle:', subtitle);
    console.log('Content:', content);
    // Add your save logic here (e.g., send a POST request to save the content)

    // Construct new Guide
  const Blog: Blog = {
    title: title,
    subtitle: subtitle,
    content: content,
    likes: 0,
  };

   // If in edit mode, add the ID to the Guide object
  if (mode === 'Add') {
    // Make the API request
    await fetch('/api/blogs', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(Blog),
    });

  }
  else {

  // Make the API request
  await fetch('/api/blogs', {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({_id, Blog}),
  });

  }

  setRefresh(!refresh);
  };

  const handleEdit = async (data: ContentData) => {

    setContent(data);
    setMode('Edit');
    setId(data._id!);


    setOpenModal(true);
  };

  const handleDelete = async (id: number) => {
    await fetch('/api/blogs', {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ _id: id }),
    });
  
    setRefresh(!refresh);
  };

  return (
    <Layout>
      <div className="flex flex-col px-4" style={{ width: '100%' }}>
      <div className="flex justify-between items-center mt-4 mb-2">
        <Typography sx={{ mt: 4, mb: 2 }} variant="h4" component="div">
          Blog
        </Typography>
        {isAdmin && (
            <Button 
              className="bg-blue-500 text-white rounded hover:bg-blue-600"
              variant="contained" 
              color="primary" 
              onClick={handleAddButtonClick}
            >
              Add Blog
            </Button>
          )}
        </div>
      </div>
      {blogs
          .map((blog, index) => (
            <div key={blog._id} style={{ display: 'flex', flexDirection: 'column' }}> {/* Ensure each guide has a unique key, using guide.id or similar */}
              <BlogCard data={{ title: blog.title, subtitle: blog.subtitle, content: blog.content }}/>
              {isAdmin && (
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <Button 
                
                  className="bg-green-500 text-white rounded hover:bg-green-600 mr-2"
                  variant="contained" 
                  color="primary" 
                  onClick={() => handleEdit(blog)}
                >
                  Edit
                </Button>
                  <Button   
                   className="bg-red-500 text-white rounded hover:bg-red-600"               
                    // style={{ 
                    //   marginTop: '10px', 
                    //   backgroundColor: '#f44336', 
                    //   color: 'white', 
                    //   border: 'none', 
                    //   borderRadius: '4px', 
                    //   cursor: 'pointer',
                    //   padding: '10px 20px'
                    // }}
                    onClick={() => handleDelete(blog._id!)}
                  >
                    Delete
                  </Button>
                </div>
              )}
              <Divider sx={{ m: 2 }}></Divider>
            </div>
          ))
        }
      <EditorModal
        open={openModal}
        handleClose={handleCloseModal}
        mode={mode}
        initialContent={content}
        onSave={handleSave}
        placeholder={placeholder}
      />
    </Layout>
  );
};

export default Page;